<p-toast [key]="infoToastKey" position="bottom-left" [baseZIndex]="9999"></p-toast>
<p-toast [key]="errorToastKey" position="bottom-left" [preventDuplicates]="true" [baseZIndex]="9999"></p-toast>
